"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApolloClient = void 0;
const apollo_boost_1 = require("apollo-boost");
const apollo_link_retry_1 = require("apollo-link-retry");
const apollo_link_schema_1 = require("apollo-link-schema");
const graphql_tools_1 = require("graphql-tools");
const isomorphic_unfetch_1 = __importDefault(require("isomorphic-unfetch"));
const utils_1 = require("../../utils");
const schema_1 = require("../schema");
const utils_2 = require("../utils");
const clients = {};
const getClientKey = (apiUrl) => (apiUrl || '').toLowerCase();
const getApolloClient = (apiUrl, manualRedirects, initialState, options, clientSideTypeDefs, clientSideResolvers, isMockApolloClient, shouldIncludeCredentials) => {
    const key = getClientKey(apiUrl);
    const apolloClientExists = clients[key];
    const shouldCreateNewApolloClientOnServer = !(0, utils_1.isClientSide)() && (!apolloClientExists || !clients[key].isMock);
    const shouldCreateNewApolloClient = !apolloClientExists || isMockApolloClient || shouldCreateNewApolloClientOnServer;
    if (shouldCreateNewApolloClient) {
        clients[key] = {
            apolloClient: createApolloClient(apiUrl, manualRedirects, initialState, options, clientSideTypeDefs, clientSideResolvers, isMockApolloClient, shouldIncludeCredentials),
            isMock: isMockApolloClient === true
        };
    }
    return clients[key].apolloClient;
};
exports.getApolloClient = getApolloClient;
const createApolloClient = (apiUrl, manualRedirects, initialState, options, clientSideTypeDefs, clientSideResolvers, isMockApolloClient, shouldIncludeCredentials) => {
    const isItBrowser = (0, utils_1.isClientSide)();
    let link;
    if (isMockApolloClient) {
        link = new apollo_link_schema_1.SchemaLink({
            schema: (0, graphql_tools_1.makeExecutableSchema)({
                resolvers: clientSideResolvers !== null && clientSideResolvers !== void 0 ? clientSideResolvers : (0, schema_1.getMockResolvers)(),
                typeDefs: clientSideTypeDefs !== null && clientSideTypeDefs !== void 0 ? clientSideTypeDefs : schema_1.mockTypeDefs
            })
        });
    }
    else {
        const customFetch = (uri, options) => {
            options.redirect = 'manual';
            return (0, isomorphic_unfetch_1.default)(uri, options).then((response) => {
                return response;
            });
        };
        const retryLink = new apollo_link_retry_1.RetryLink({
            attempts: {
                max: 3,
                retryIf: utils_2.shouldRetryOnNetworkError
            },
            delay: {
                initial: 300,
                jitter: true,
                max: 10000
            }
        });
        const httpLink = new apollo_boost_1.HttpLink({
            credentials: shouldIncludeCredentials ? 'include' : 'same-origin',
            fetch: manualRedirects ? customFetch : !isItBrowser || !window ? isomorphic_unfetch_1.default : window.fetch,
            uri: apiUrl
        });
        link = apollo_boost_1.ApolloLink.from([retryLink, httpLink]);
    }
    return new apollo_boost_1.ApolloClient(Object.assign({ cache: new apollo_boost_1.InMemoryCache({
            addTypename: false
        }).restore(initialState || {}), connectToDevTools: isItBrowser, link: link, resolvers: clientSideResolvers, ssrMode: !isItBrowser, typeDefs: clientSideTypeDefs }, options));
};
